// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._1reo15vq{overflow-x:hidden}\n._kqswh2mm{position:relative}\n._lcxvglyw{pointer-events:none}", ""]);
// Exports
module.exports = exports;
